import React from 'react'

function Header() {
    return (
        <div className="header">
            <h1>Keep Shorts</h1>
            <h4 style={{color: "black"}}>Save notes, quotes, list</h4>
        </div>
    )
}

export default Header
